/**
 * Initialization progress bar with percentage indicator.
 */

import React from "react";

import {
  Box,
  Typography,
  LinearProgress,
  alpha,
  useTheme,
} from "@mui/material";

interface LoadingProgressBarProps {
  progress: number;
}

export const LoadingProgressBar: React.FC<LoadingProgressBarProps> = ({
  progress,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: "0.875rem",
          }}
        >
          Initialization Progress
        </Typography>
        <Typography
          variant="h6"
          component="span"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: "1.25rem",
            minWidth: "50px",
            textAlign: "right",
          }}
        >
          {Math.round(progress)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          bgcolor: alpha(theme.palette.primary.main, 0.15),
          overflow: "hidden",
          "& .MuiLinearProgress-bar": {
            borderRadius: 4,
            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.info.main} 100%)`,
            transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
          },
        }}
      />
    </Box>
  );
};

export default LoadingProgressBar;
